export const DataLayer = () => {
  return {
    getDataLayer() {
      return window.dataLayer;
    },
    push(params: Object) {
      this.getDataLayer().push(params);
    }
  };
}